"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AnomalyTransformer", {
    enumerable: true,
    get: function() {
        return AnomalyTransformer;
    }
});
const _anomaly = require("../common/anomaly");
let AnomalyTransformer = class AnomalyTransformer {
    /**
   * Transforms a raw Anomaly into a display-ready ProcessedAnomaly object.
   */ static getProcessedAnomaly(anomaly) {
        const bugId = anomaly.bug_id;
        const testPathPieces = anomaly.test_path.split('/');
        const bot = testPathPieces[1];
        const testsuite = testPathPieces[2];
        const test = testPathPieces.slice(3, testPathPieces.length).join('/');
        const revision = anomaly.start_revision;
        const delta = (0, _anomaly.getPercentChange)(anomaly.median_before_anomaly, anomaly.median_after_anomaly);
        return {
            bugId,
            revision,
            bot,
            testsuite,
            test,
            delta,
            isImprovement: anomaly.is_improvement
        };
    }
    /**
   * Computes a readable revision range string.
   */ static computeRevisionRange(start, end) {
        if (start === null || end === null) {
            return '';
        }
        if (start === end) {
            return '' + end;
        }
        return start + ' - ' + end;
    }
    /**
   * Finds the longest common test path prefix for a list of anomalies.
   * Used for group summary rows.
   */ static findLongestSubTestPath(anomalyList) {
        if (anomalyList.length === 0) {
            return '';
        }
        const getTestPartTokens = (testPath)=>{
            return testPath.split('/').slice(3);
        };
        let commonTokens = getTestPartTokens(anomalyList[0].test_path);
        if (commonTokens.length === 0 || commonTokens.length === 1 && commonTokens[0] === '') {
            return '*';
        }
        for(let i = 1; i < anomalyList.length; i++){
            const currentTokens = getTestPartTokens(anomalyList[i].test_path);
            let matchCount = 0;
            for(let j = 0; j < commonTokens.length && j < currentTokens.length; j++){
                if (commonTokens[j] === currentTokens[j]) {
                    matchCount++;
                } else {
                    break;
                }
            }
            commonTokens = commonTokens.slice(0, matchCount);
            if (commonTokens.length === 0) {
                return '*';
            }
        }
        const originalTokens = getTestPartTokens(anomalyList[0].test_path);
        if (commonTokens.length !== originalTokens.length) {
            return commonTokens.join('/') + '/*';
        }
        return commonTokens.join('/');
    }
    /**
   * Determines the summary delta for a group of anomalies.
   * Returns [deltaValue, isRegression].
   */ static determineSummaryDelta(anomalyGroup) {
        const regressions = anomalyGroup.anomalies.filter((a)=>!a.is_improvement);
        let targetAnomalies = anomalyGroup.anomalies;
        if (regressions.length > 0) {
            // If there are regressions, find the one with the largest magnitude.
            targetAnomalies = regressions;
        }
        if (targetAnomalies.length === 0) {
            return [
                0,
                false
            ];
        }
        const biggestChangeAnomaly = targetAnomalies.reduce((prev, current)=>{
            const prevDelta = Math.abs((0, _anomaly.getPercentChange)(prev.median_before_anomaly, prev.median_after_anomaly));
            const currentDelta = Math.abs((0, _anomaly.getPercentChange)(current.median_before_anomaly, current.median_after_anomaly));
            return prevDelta > currentDelta ? prev : current;
        });
        return [
            (0, _anomaly.getPercentChange)(biggestChangeAnomaly.median_before_anomaly, biggestChangeAnomaly.median_after_anomaly),
            regressions.length > 0
        ];
    }
};
